import React from "react";
import { motion } from "framer-motion";

function TabButton({ tab, active, onClick }) {
  return (
    <motion.button
      onClick={() => onClick(tab.id)}
      whileHover={{ y: -2 }}
      whileTap={{ scale: 0.95 }}
      className={`relative flex items-center gap-2 px-5 py-2.5 rounded-full text-sm
        transition-colors duration-300 overflow-hidden
        ${
          active
            ? "text-[#05050b]"
            : "text-white/40 border border-white/[0.07] hover:text-white/70 hover:border-white/15 bg-white/[0.02]"
        }`}
      style={{ fontFamily: "'DM Mono', monospace" }}
    >
      {active && (
        <motion.div
          layoutId="tab-active"
          className="absolute inset-0 rounded-full"
          style={{ background: "linear-gradient(135deg, #00f0ff, #0047ff)" }}
          transition={{ type: "spring", stiffness: 380, damping: 32 }}
        />
      )}
      <span className="relative z-10 text-[10px] tracking-[0.18em] uppercase">
        {tab.label}
      </span>
      <span
        className={`relative z-10 text-[9px] px-1.5 py-0.5 rounded-full tracking-wide
          ${active ? "bg-black/20 text-[#05050b]/80" : "bg-white/[0.06] text-white/30"}`}
      >
        {tab.count}
      </span>
    </motion.button>
  );
}

export default TabButton;
